export const OAUTH_CODE_STATUS = 'OAUTH_CODE_STATUS';
export const OAUTH_CODE_CHECKING = 'OAUTH_CODE_CHECKING';
export const OAUTH_USER_AUTHORIZED = 'OAUTH_USER_AUTHORIZED';
export const OAUTH_CODE = 'OAUTH_CODE';
